import { gql } from '@apollo/client';
const ADD_PRODUCT_PICTURES = gql `
  mutation AddProductPictures($productId: ID!, $files: [String!]!) {
    addProductPictures(productId: $productId, files: $files) {
      product {
        id
        pictures {
          edges {
            node {
              id
              image
            }
          }
        }
      }
    }
  }
`;
export default ADD_PRODUCT_PICTURES;
